import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import "./clinic.css";
import SiteMotion from "./components/feature/SiteMotion";
import WhatsAppButton from "./components/feature/WhatsAppButton";
import ContentProtection from "./components/feature/ContentProtection";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        <SiteMotion />
        <WhatsAppButton />
        <ContentProtection />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
